import React, { useEffect } from 'react';
import { useAppDispatch } from 'services/configuration/store/hooks';
import { obliczeniaSlice, setStateFromQueryParams } from 'services/slices/obliczeniaSlice/obliczeniaSlice';
import { AVAILABLE_SCENARIOS, defaultScenario } from 'services/slices/obliczeniaSlice/scenarios';
import { setUiStateFromQueryParams } from 'services/slices/uiSlice';

import { mergeProdukcjaEnergii } from './mergeProdukcjaEnergii';
import { mergeObliczenia } from './mergeObliczenia';
import { mergeKoszty } from './mergeKoszty';
import { getSearchParam } from './utils';
import { mergeWodor } from './mergeWodor';
import { updateScenario } from 'services/slices/periodSlice';

export const AppParams = () => {
  const dispatch = useAppDispatch();
  const selectedScenario =
    AVAILABLE_SCENARIOS.find((el, i) => i === Number(getSearchParam('scenario'))) || defaultScenario;

  useEffect(() => {
    const produkcjaEnergiiElektrycznejMerged = mergeProdukcjaEnergii(
      obliczeniaSlice.getInitialState().produkcjaEnergiiElektrycznej,
      selectedScenario.data,
    );

    const obliczeniaMerged = mergeObliczenia(obliczeniaSlice.getInitialState().obliczenia, selectedScenario.data);
    const kosztyMerged = mergeKoszty();
    const wodorMerged = mergeWodor(obliczeniaSlice.getInitialState().wodór, selectedScenario.data);
    dispatch(updateScenario(selectedScenario));
    dispatch(
      setStateFromQueryParams({
        produkcjaEnergiiElektrycznej: produkcjaEnergiiElektrycznejMerged,
        obliczenia: obliczeniaMerged,
        koszty: kosztyMerged,
        wodor: wodorMerged,
      }),
    );

    const uiStateRaw = getSearchParam('ui');
    if (uiStateRaw) {
      try {
        const uiState = JSON.parse(uiStateRaw);
        dispatch(setUiStateFromQueryParams(uiState));
      } catch (error) {
        console.error('Error parsing UI state from URL:', error);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
